export default __webpack_public_path__ + "static/media/ThreePigs_02.eb885b85.png";